import type {
  FormModuleComponent,
  Recaptcha,
} from 'services/content/components/types/FormModule'
import OnrampMailingListCTA from 'ui-component-library/components/OnrampMailingListCTA'
import FormModule from 'containers/FormModule'

type Props = {
  notifyText: string
  formModule: {
    components: FormModuleComponent[]
    submitButtonText: string
    submitUrl: string
    recaptcha?: Recaptcha
    invalidText: string
    errorText: string
    successText: string
  }
}

function OnrampMailingListCTAContainer({ formModule, notifyText }: Props) {
  return (
    <OnrampMailingListCTA
      notifyText={notifyText}
      renderFormModule={(styleOverrides) => (
        <FormModule {...formModule} styleOverrides={styleOverrides} />
      )}
    />
  )
}

export default OnrampMailingListCTAContainer
